<template>
  <div>

  </div>
</template>

<script>
// Rekapitulacija placa za razdoblje.
// One row per employee with Ukupno sati, Bruto 2, Neto (before the non taxable part)
// and, when asked for, Neoporezivo and Za isplatu. Every column is totalled.
// With the details turned on each obracun of the employee is printed above the
// employee subtotal.
//
// The numbers come from freeSalarieRecap through store.printObj.

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import dayjs from 'dayjs'

// Fixed widths in points, the name column takes what is left over.
const W = {rbr: 20, name: '*', oib: 66, hours: 50, money: 68}

const LINE = '#9e9e9e'
const HEAD_BG = '#eeeeee'
const SUB_BG = '#f6f6f6'

export default {
  name: 'salarieprintrecap',
  props: [],
  data () {
    return {
      comp: {},
      ana: {},
      docDefinition: null,
      content: []
    }
  },
  methods: {
    print () {
      this.comp = this.$store.state.companyActiv ? this.$store.state.companyActiv : {}
      this.ana = this.$store.state.printObj ? this.$store.state.printObj : {}
      const recap = this.ana.recap ? this.ana.recap : {employees: [], totals: {}, obracuni: 0}
      if (!recap.employees || recap.employees.length === 0) {
        alert('Nema obračuna u odabranom razdoblju.')
        return
      }
      this.printDoc(recap)
    },

    formatPrice (value) {
      const val = (this.num(value) / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatHours (value) {
      const val = (this.num(value) / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    num (value) {
      const n = parseFloat(value)
      return isNaN(n) ? 0 : n
    },
    // "3/2025 Obračun plaće za, JOPPD 25085 (08.04.2025)"
    lineLabel (line) {
      const period = (line.Month ? line.Month : '?') + '/' + (line.Year ? line.Year : '?')
      const vrsta = line.VrstaObracuna ? ' ' + line.VrstaObracuna : ''
      const joppd = line.BrojJoppd ? ', JOPPD ' + line.BrojJoppd : ''
      const date = line.JoppdDate ? ' (' + dayjs(line.JoppdDate).format('DD.MM.YYYY') + ')' : ''
      return period + vrsta + joppd + date
    },

    printDoc (recap) {
      const showNotax = this.ana.showNotax !== false
      const showDetails = this.ana.hideDetails !== true

      pdfMake.addVirtualFileSystem(pdfFonts)
      this.content = []
      this.content.push(this.head(recap))
      this.content.push(this.table(recap, showNotax, showDetails))
      this.content.push(this.legend(showNotax))

      this.docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [20, 20, 20, 30],
        content: this.content,
        footer: (currentPage, pageCount) => ({
          text: 'Stranica ' + currentPage + ' od ' + pageCount,
          fontSize: 7,
          alignment: 'right',
          margin: [0, 8, 20, 0]
        })
      }
      pdfMake.createPdf(this.docDefinition).open()
    },

    head (recap) {
      const period = (this.ana.startDate ? dayjs(this.ana.startDate).format('DD.MM.YYYY') : '') +
        ' - ' + (this.ana.endDate ? dayjs(this.ana.endDate).format('DD.MM.YYYY') : '')
      return {
        columns: [
          {
            width: '35%',
            text: [
              {text: (this.comp.CompanyName ? this.comp.CompanyName : '') + ' \n', fontSize: 10, bold: true},
              {text: (this.comp.CompanyStreet ? this.comp.CompanyStreet : '') + ' ' + (this.comp.CompanyBuildingNameNumber ? this.comp.CompanyBuildingNameNumber : '') + ' \n', fontSize: 8},
              {text: (this.comp.CompanyPostcode ? this.comp.CompanyPostcode : '') + ' ' + (this.comp.CompanyCity ? this.comp.CompanyCity : '') + ' \n', fontSize: 8},
              {text: 'OIB: ' + (this.comp.CompanyVATID ? this.comp.CompanyVATID : ''), fontSize: 8}
            ]
          },
          {
            width: '45%',
            text: [
              {text: 'Rekapitulacija plaća \n', fontSize: 16, bold: true},
              {text: 'za razdoblje ' + period + ' \n', fontSize: 11, bold: true},
              // says so on the report itself when it was run for one employee
              {text: (this.ana.employeeName ? 'radnik: ' + this.ana.employeeName + ' \n' : ''), fontSize: 9, bold: true},
              {text: 'prema datumu JOPPD obrasca \n', fontSize: 7},
              {text: 'Radnika: ' + recap.employees.length + ', obračuna: ' + recap.obracuni, fontSize: 8}
            ]
          },
          {
            width: '20%',
            text: [
              {text: 'Datum ispisa: ' + dayjs().format('DD.MM.YYYY HH:mm'), fontSize: 8}
            ]
          }
        ],
        columnGap: 10,
        margin: [0, 0, 0, 10]
      }
    },

    columnWidths (showNotax) {
      const widths = [W.rbr, W.name, W.oib, W.hours, W.money, W.money]
      if (showNotax) { widths.push(W.money, W.money) }
      return widths
    },

    headerRow (showNotax) {
      const cell = (text, align, sub) => ({
        text: sub ? [{text: text + '\n', bold: true}, {text: sub, fontSize: 6, bold: false}] : text,
        fontSize: 8,
        bold: true,
        alignment: align || 'left',
        fillColor: HEAD_BG,
        margin: [2, 3, 2, 3]
      })
      const row = [
        cell('Rbr', 'left'),
        cell('Radnik', 'left'),
        cell('OIB', 'left'),
        cell('Ukupno sati', 'right'),
        cell('Bruto 2', 'right'),
        cell('Neto', 'right', 'bez neoporezivog')
      ]
      if (showNotax) {
        row.push(cell('Neoporezivo', 'right'))
        row.push(cell('Za isplatu', 'right', 'neto + neoporezivo'))
      }
      return row
    },

    // One printed row. `style` is 'detail', 'person' or 'total'.
    bodyRow (cells, style) {
      const bold = style !== 'detail'
      const fill = style === 'person' ? SUB_BG : (style === 'total' ? HEAD_BG : null)
      const size = style === 'detail' ? 7 : 8
      return cells.map((cell, index) => ({
        text: cell.text,
        fontSize: size,
        bold: bold,
        alignment: cell.align || 'left',
        fillColor: fill,
        margin: [2, style === 'detail' ? 1 : 2, 2, style === 'detail' ? 1 : 2],
        // the obracun label is indented under the employee it belongs to
        ...(style === 'detail' && index === 1 ? {margin: [12, 1, 2, 1], color: '#555555'} : {})
      }))
    },

    amountCells (sums, showNotax) {
      const cells = [
        {text: this.formatHours(sums.hours), align: 'right'},
        {text: this.formatPrice(sums.bruto2), align: 'right'},
        {text: this.formatPrice(sums.neto), align: 'right'}
      ]
      if (showNotax) {
        cells.push({text: this.formatPrice(sums.notax), align: 'right'})
        cells.push({text: this.formatPrice(sums.payout), align: 'right'})
      }
      return cells
    },

    table (recap, showNotax, showDetails) {
      const body = [this.headerRow(showNotax)]
      let rbr = 0

      // The employee and their totals come first, the obracuni they are made of are
      // listed underneath.
      recap.employees.forEach(person => {
        rbr += 1
        body.push(this.bodyRow([
          {text: String(rbr)},
          {text: person.FullName},
          {text: person.VatID}
        ].concat(this.amountCells(person.totals, showNotax)), 'person'))
        if (showDetails) {
          person.lines.forEach(line => {
            body.push(this.bodyRow([
              {text: ''},
              {text: this.lineLabel(line)},
              {text: ''}
            ].concat(this.amountCells(line, showNotax)), 'detail'))
          })
        }
      })

      body.push(this.bodyRow([
        {text: ''},
        {text: 'SVEUKUPNO (' + recap.employees.length + ' radnika)'},
        {text: ''}
      ].concat(this.amountCells(recap.totals, showNotax)), 'total'))

      return {
        table: {
          headerRows: 1,
          dontBreakRows: true,
          widths: this.columnWidths(showNotax),
          body: body
        },
        layout: {
          hLineWidth: (i, node) => (i === 0 || i === 1 || i === node.table.body.length ? 1 : 0.5),
          vLineWidth: () => 0.5,
          hLineColor: () => LINE,
          vLineColor: () => LINE
        }
      }
    },

    legend (showNotax) {
      const parts = [
        'Ukupno sati - zbroj svih vrsta sati obračuna.',
        'Bruto 2 - bruto plaća uvećana za dodatke (FinBruto2).',
        'Neto - neto plaća nakon poreza i prireza, bez neoporezivih primitaka.'
      ]
      if (showNotax) {
        parts.push('Neoporezivo - neoporezivi primici i naknada HZZO-a.')
      }
      return {
        text: parts.join(' '),
        fontSize: 6,
        color: '#666666',
        margin: [0, 8, 0, 0]
      }
    }
  }
}
</script>
